import React from 'react';
import { SearchIcon, ShieldCheckIcon, AlertTriangleIcon } from 'lucide-react';
export function FeatureCards() {
  const features = [{
    title: 'Find Safe Restaurants',
    icon: SearchIcon,
    color: 'bg-sky-100 text-sky-600',
    examples: ['"Best rated sushi near me?"', '"Cleanest restaurants downtown?"']
  }, {
    title: 'Check Any Restaurant',
    icon: ShieldCheckIcon,
    color: 'bg-emerald-100 text-emerald-600',
    examples: ['"Is Bella Napoli safe to eat at?"', '"When was The Rustic Table last inspected?"']
  }, {
    title: 'Understand Violations',
    icon: AlertTriangleIcon,
    color: 'bg-amber-100 text-amber-600',
    examples: ['"What violations did Golden Dragon have?"', '"Which places have critical issues?"']
  }];
  return <section className="py-20 bg-white" data-id="element-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-51">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-52">
          <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-53">
            What can you ask?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-54">
            Our AI understands natural language questions about restaurant
            safety in Franklin County. Just ask like you would a health
            inspector.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-55">
          {features.map((feature, index) => <div key={index} className="bg-white rounded-2xl p-8 border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-56">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 ${feature.color}`} data-id="element-57">
                <feature.icon className="w-6 h-6" data-id="element-58" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-4" data-id="element-59">
                {feature.title}
              </h3>
              <div className="space-y-3" data-id="element-60">
                {feature.examples.map((example, idx) => <div key={idx} className="flex items-start" data-id="element-61">
                    <span className="text-slate-300 mr-2" data-id="element-62">→</span>
                    <span className="text-slate-600 italic" data-id="element-63">{example}</span>
                  </div>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}